// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__5VVFL","label":"Category_label__13Y2f","content":"Category_content__2vP7f","header":"Category_header__1x2P7","location":"Category_location__1oDBo"};